
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, list_type, bool_type, lambda_type, unit_type, union_type, class_type, int32_type, option_type, anonRecord_type, string_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Storage_$reflection } from "../../../Shared/Storage.js";
import { FormState__startLoading, FormState_get_empty, UpdateStockDto, StorageId_$reflection, FormState_$reflection, ToolId_$reflection, UpdateStockDto_$reflection, PostResponse$1_$reflection, UpdateStockResult_$reflection } from "../../../Shared/Shared.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none, Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../../Communication.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton, filter, map, tryFind, ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { join, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast } from "../../../Components/Toast.js";
import { unwrapStorageId } from "../../../Shared/Helper.js";
import { createObj, equals } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Select } from "../../../Components/Select.js";
import { map as map_1, unwrap } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { NumberInput } from "../../../Components/Input.js";
import { numberInputIntMaxValue } from "../../../Common.js";
import { TextArea } from "../../../Components/TextArea.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../../Components/Dialog.js";
import { TextButton } from "../../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetSelectedStorage", "SetQuantity", "SetComment", "UpdateStock", "StockUpdatedResponse", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Tools.StockChangeDialog.Msg", [], Msg, () => [[["Item", option_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))]], [["Item", option_type(int32_type)]], [["Item", string_type]], [], [["Item", PostResponse$1_$reflection(UpdateStockResult_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

function postStockChangeCmd(toolId, dto) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(tupledArg[0]), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(UpdateStockResult_$reflection())));
    })))), [concat("/api/tools/", toolId.fields[0], ..."/stock"), toString(0, Auto_generateBoxedEncoder_437914C6(UpdateStockDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new Msg(4, [Item])), (Item_1) => (new Msg(5, [Item_1])));
}

class State extends Record {
    constructor(ToolId, Dto, FormState, SuccessCallback, OnClose, IsQuantityInvalid, IsCommentInvalid, IsStockNegative, StorageId, Storages, IsStorageInvalid, SelectedStorage) {
        super();
        this.ToolId = ToolId;
        this.Dto = Dto;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.IsQuantityInvalid = IsQuantityInvalid;
        this.IsCommentInvalid = IsCommentInvalid;
        this.IsStockNegative = IsStockNegative;
        this.StorageId = StorageId;
        this.Storages = Storages;
        this.IsStorageInvalid = IsStorageInvalid;
        this.SelectedStorage = SelectedStorage;
    }
}

function State_$reflection() {
    return record_type("Tools.StockChangeDialog.State", [], State, () => [["ToolId", ToolId_$reflection()], ["Dto", UpdateStockDto_$reflection()], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["IsQuantityInvalid", bool_type], ["IsCommentInvalid", bool_type], ["IsStockNegative", bool_type], ["StorageId", option_type(StorageId_$reflection())], ["Storages", list_type(Storage_$reflection())], ["IsStorageInvalid", bool_type], ["SelectedStorage", option_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))]]);
}

function update(msg, state) {
    let bind$0040, bind$0040_1, bind$0040_2;
    switch (msg.tag) {
        case 1: {
            const value_1 = msg.fields[0];
            if (value_1 == null) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.ToolId, (bind$0040 = state.Dto, new UpdateStockDto(bind$0040.StorageId, value_1, bind$0040.Comment)), state.FormState, state.SuccessCallback, state.OnClose, state.IsQuantityInvalid, state.IsCommentInvalid, state.IsStockNegative, state.StorageId, state.Storages, state.IsStorageInvalid, state.SelectedStorage), Cmd_none()];
            }
        }
        case 2:
            return [new State(state.ToolId, (bind$0040_1 = state.Dto, new UpdateStockDto(bind$0040_1.StorageId, bind$0040_1.Quantity, msg.fields[0])), state.FormState, state.SuccessCallback, state.OnClose, state.IsQuantityInvalid, state.IsCommentInvalid, state.IsStockNegative, state.StorageId, state.Storages, state.IsStorageInvalid, state.SelectedStorage), Cmd_none()];
        case 4:
            if (msg.fields[0].Result.tag === 1) {
                return [new State(state.ToolId, state.Dto, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.IsQuantityInvalid, state.IsCommentInvalid, true, state.StorageId, state.Storages, state.IsStorageInvalid, state.SelectedStorage), Cmd_none()];
            }
            else {
                return [new State(state.ToolId, state.Dto, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.IsQuantityInvalid, state.IsCommentInvalid, state.IsStockNegative, state.StorageId, state.Storages, state.IsStorageInvalid, state.SelectedStorage), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                }), Cmd_successToast("tool.dialog_stock_change_success")]))];
            }
        case 3: {
            const matchValue_1 = state.SelectedStorage;
            if (matchValue_1 == null) {
                return [new State(state.ToolId, state.Dto, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.IsQuantityInvalid, state.IsCommentInvalid, state.IsStockNegative, state.StorageId, state.Storages, true, state.SelectedStorage), Cmd_none()];
            }
            else {
                const storage = matchValue_1;
                if (state.Dto.Comment === "") {
                    return [new State(state.ToolId, state.Dto, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.IsQuantityInvalid, true, state.IsStockNegative, state.StorageId, state.Storages, state.IsStorageInvalid, state.SelectedStorage), Cmd_none()];
                }
                else {
                    return [new State(state.ToolId, state.Dto, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.IsQuantityInvalid, false, state.IsStockNegative, state.StorageId, state.Storages, state.IsStorageInvalid, state.SelectedStorage), postStockChangeCmd(state.ToolId, (bind$0040_2 = state.Dto, new UpdateStockDto(unwrapStorageId(storage.value.Id), bind$0040_2.Quantity, bind$0040_2.Comment)))];
                }
            }
        }
        case 5:
            return [new State(state.ToolId, state.Dto, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.IsQuantityInvalid, state.IsCommentInvalid, state.IsStockNegative, state.StorageId, state.Storages, state.IsStorageInvalid, state.SelectedStorage), Cmd_none()];
        default:
            return [new State(state.ToolId, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.IsQuantityInvalid, state.IsCommentInvalid, state.IsStockNegative, state.StorageId, state.Storages, state.IsStorageInvalid, msg.fields[0]), Cmd_none()];
    }
}

function init(toolId, storageId, storages, successCallback, onClose) {
    let storageId_2, matchValue, storage;
    return [new State(toolId, new UpdateStockDto((storageId == null) ? "" : unwrapStorageId(storageId), 1, ""), FormState_get_empty(), successCallback, onClose, false, false, false, storageId, storages, false, (storageId == null) ? undefined : ((storageId_2 = storageId, (matchValue = tryFind((s) => equals(s.Id, storageId_2), storages), (matchValue == null) ? undefined : ((storage = matchValue, {
        label: storage.Name,
        value: storage,
    })))))), Cmd_none()];
}

function DialogBody(props) {
    let matchValue, storage, elems, Label_1, Value_1;
    const t = useTranslation()[0];
    const storages = map((storage_1) => ({
        label: storage_1.Name,
        value: storage_1,
    }), (matchValue = props.SelectedStorage, (matchValue == null) ? props.Storages : ((storage = matchValue, filter((s) => !equals(s.Id, storage.value.Id), props.Storages)))));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems = [createElement(Select, {
        ComponentState: props.FormState,
        IsClearable: false,
        Label: t("tool.switch_storage_target"),
        NoOptionsMessage: "",
        OnChange: props.SetSelectedStorage,
        Options: storages,
        PlaceholderKey: "",
        TestId: "",
        ValidationMessage: unwrap(props.IsStorageInvalid ? "" : undefined),
        Value: unwrap(props.SelectedStorage),
    }), createElement(NumberInput, (Label_1 = t("tool.change_in_stock"), (Value_1 = map_1((value_1) => value_1, props.Dto.Quantity), {
        ComponentState: props.FormState,
        Label: unwrap(Label_1),
        MaxValue: numberInputIntMaxValue,
        OnChange: (arg) => {
            props.SetQuantity(map_1((value_2) => (~~value_2 | 0), arg));
        },
        TestId: "",
        ValidationMessage: unwrap(props.IsQuantityInvalid ? t("tool.change_in_stock_invalid_msg") : (props.IsStockNegative ? t("tool.change_in_stock_negative_msg") : undefined)),
        Value: unwrap(Value_1),
    }))), createElement(TextArea, {
        ComponentState: props.FormState,
        Label: t("general.comment"),
        OnChange: props.SetComment,
        TestId: "",
        ValidationMessage: unwrap(props.IsCommentInvalid ? t("tool.dialog_stock_change_validation") : undefined),
        Value: props.Dto.Comment,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function ChangeStockDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.ToolId, props.StorageId, props.Storages, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = t("tool.update_stock"), {
        Body: singleton(createElement(DialogBody, {
            Dto: state_1.Dto,
            FormState: componentState,
            IsCommentInvalid: state_1.IsCommentInvalid,
            IsQuantityInvalid: state_1.IsQuantityInvalid,
            IsStockNegative: state_1.IsStockNegative,
            IsStorageInvalid: state_1.IsStorageInvalid,
            SelectedStorage: unwrap(state_1.SelectedStorage),
            SetComment: (value) => {
                dispatch(new Msg(2, [value]));
            },
            SetQuantity: (value_1) => {
                dispatch(new Msg(1, [value_1]));
            },
            SetSelectedStorage: (value_2) => {
                dispatch(new Msg(0, [value_2]));
            },
            Storages: state_1.Storages,
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-stock-change-dialog-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Msg(3, []));
            },
            TestId: "save-stock-change-dialog-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

